import React, { useMemo } from "react";
import { BodyMediumMidEmphasis } from "@/design-system";
import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { groupBy } from "lodash";
import { CTAMapper } from '@/pages/FlyerDetails/CtaMapper';
import { CallToAction } from "@/graphql/types";
import { pxToRem } from "@/utils";
import { AccessibleDivButton } from "@/components";

type Props = {
  ctas: CallToAction[];
  trackId: string;
  openLink: ({ origin, value, cta, featureId }: { origin: string, value: string, cta: string, featureId?: string | null }) => void
};

const FeatureLinkCards: React.FC<Props> = ({ ctas, trackId, openLink }) => {
  if(ctas.length == 0) return null;

  const ctasByType = useMemo(() =>
    groupBy(ctas, cta => {
      return cta.type;
    }),
  [ctas]);

  const sortedKeys = useMemo(() => Object.keys(ctasByType).sort((a, b) => {
    const orderA = CTAMapper[a].order;
    const orderB = CTAMapper[b].order;
    return orderA - orderB;
  }), [ctasByType]);


  return (
    <div className={styles.container}>
      {
        sortedKeys.map(key => {
          const Icon = CTAMapper[key].icon;
          const cta = ctasByType[key][0];

          return (
            <AccessibleDivButton
              className={styles.card}
              key={key}
              onClick={() => openLink({
                origin: `${trackId}:cta:${cta.type}:${cta.value}`,
                value: cta.value,
                cta: key,
                featureId: cta.id
              })}
             >
              <div className={styles.icon}>
                <Icon />
              </div>
              <div>
                <BodyMediumMidEmphasis className={styles.label}>
                  {CTAMapper[key].label}
                </BodyMediumMidEmphasis>
              </div>
            </AccessibleDivButton>
          )
        })
      }
    </div>
  );
}

const styles = {
  container: css`
    margin-bottom: 16px;
    padding-bottom:16px;
    border-bottom: 1px solid ${colors.silver};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`,
card: css`
  display: flex;
  width: ${pxToRem(64)};
  margin: 0px 6px 0px 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  cursor: pointer;
`,
icon: css`
  display: flex;
  padding: ${pxToRem(16)};
  margin-bottom: 8px;
  border-radius: ${pxToRem(32)};
  border: 1px solid ${colors.prussian700};
  svg {
    color: ${colors.prussian}
  }
`,
label: css`
  white-space: nowrap;
`,
}

export { FeatureLinkCards };
